export default {
  route: {
    Student: 'Student Management',
    StudentList: 'Student List'
  },
  '学生管理': 'Student Management',
  '学生列表': 'Student List',
  '添加学生': 'Add Student',
  '请输入学生姓名或学号': 'Enter student name or student number',
  '请输入学生姓名、手机号或留言详情': 'Enter student name, phone number or message detail',
  '删除选中': 'Delete selected',
  '状态': 'Status',
  '搜索': 'Search',
  '清空': 'Clear',
  '启用': 'Enable',
  '禁用': 'Disable',
  '操作': 'Action',
  '详情': 'Detail',
  '删除': 'Delete',
  '学生详情': 'Student Detail',

  'ID': 'ID',
  '姓名': 'Name',
  '学号': 'Student No',
  '年龄': 'Age',
  '性别': 'Gender',
  '男': 'Male',
  '女': 'Female',
  '班级': 'Class',
  '手机号': 'Phone',
  '邮箱': 'Email',
  '留言详情': 'Message Detail',
  '创建时间': 'Create Time',
  '时间': 'Time',

  '请输入学生姓名': 'Enter student name',
  '请输入学号': 'Enter student number',
  '请输入学号（可选）': 'Enter student number (optional)',
  '请输入年龄': 'Enter age',
  '请输入班级': 'Enter class',
  '请输入班级（可选）': 'Enter class (optional)',
  '请输入手机号': 'Enter phone number',
  '请输入邮箱': 'Enter email',
  '请输入邮箱（可选）': 'Enter email (optional)',
  '请输入留言详情（可选）': 'Enter message detail (optional)',
  '请输入正确的邮箱格式': 'Enter correct email format',

  '确认要删除该学生吗？': 'Are you sure to delete this student?',
  '确认要删除选中的学生吗？': 'Are you sure to delete selected students?',
  '请选择要删除的学生': 'Please select students to delete',
  '删除选择的学生成功': 'Selected students deleted successfully',
  '学生添加成功': 'Student added successfully',
  '学生删除成功': 'Student deleted successfully',
  '学生信息不存在': 'Student information does not exist',
  '学生ID不能为空': 'Student ID cannot be empty',
  '学生姓名不能为空': 'Student name cannot be empty',
  '学号不能为空': 'Student number cannot be empty',
  '年龄必须在1-100之间': 'Age must be between 1-100',
  '手机号不能为空': 'Phone number cannot be empty',
  '邮箱不能为空': 'Email cannot be empty',

  '取消': 'Cancel',
  '确定': 'OK',
  '提示': 'Tip'
}
